import React from 'react';
import './style.scss';

export const ActionButton = ({
  buttonName,
  disabled,
  iconRight,
  iconLeft,
  className,
  iconClass,
  onClick,
  style,
}) => {
  return (
    <button
      className={className}
      onClick={onClick}
      type={'button'}
      disabled={disabled}
      style={style}
    >
      {iconLeft && <img className={iconClass} src={iconLeft} alt="icon" />}
      {buttonName}
      {iconRight && <img className={iconClass} src={iconRight} alt="icon" />}
    </button>
  );
};
